import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { TeamWithUsersFragmentDoc } from '../../fragments/__generated__/teamWithUsers';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamWithUsersQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  constantName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  region?: Types.InputMaybe<Types.RegionEnum>;
}>;


export type TeamWithUsersQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: number, label: string, constantName: string, region: Types.RegionEnum, teamType?: string | null, users: Array<{ __typename?: 'TeamMembership', id: number, membershipType: Types.MembershipTypeEnum, teamId: string, user: { __typename?: 'User', id: number, name: string, imageUrl?: string | null } }>, recursiveParents: Array<{ __typename?: 'Team', id: number, constantName: string, label: string }>, parentTeam?: { __typename?: 'Team', id: number, constantName: string, label: string } | null } };


export const TeamWithUsersDocument = gql`
    query teamWithUsers($id: ID, $constantName: String, $region: RegionEnum) {
  team(id: $id, constantName: $constantName, region: $region) {
    ...teamWithUsers
  }
}
    ${TeamWithUsersFragmentDoc}`;

/**
 * __useTeamWithUsersQuery__
 *
 * To run a query within a React component, call `useTeamWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamWithUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      constantName: // value for 'constantName'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useTeamWithUsersQuery(baseOptions?: Apollo.QueryHookOptions<TeamWithUsersQuery, TeamWithUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamWithUsersQuery, TeamWithUsersQueryVariables>(TeamWithUsersDocument, options);
      }
export function useTeamWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamWithUsersQuery, TeamWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamWithUsersQuery, TeamWithUsersQueryVariables>(TeamWithUsersDocument, options);
        }
export function useTeamWithUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamWithUsersQuery, TeamWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamWithUsersQuery, TeamWithUsersQueryVariables>(TeamWithUsersDocument, options);
        }
export type TeamWithUsersQueryHookResult = ReturnType<typeof useTeamWithUsersQuery>;
export type TeamWithUsersLazyQueryHookResult = ReturnType<typeof useTeamWithUsersLazyQuery>;
export type TeamWithUsersSuspenseQueryHookResult = ReturnType<typeof useTeamWithUsersSuspenseQuery>;
export type TeamWithUsersQueryResult = Apollo.QueryResult<TeamWithUsersQuery, TeamWithUsersQueryVariables>;